
  <div class="calendar-container">
    <!-- Days Container -->
    <div class="days-container">
  <!-- Loop through the next 7 days -->
      <div *ngFor="let day of weekDays" 
           [ngClass]="{'today-highlight': isToday(day)}"
           class="calendar-day">
        <!-- Day Header -->
        <div class="day-header">
          <div class="day-name">{{ day | date: 'EEE' }}</div>
          <div class="day-date">{{ day | date: 'MMM dd' }}</div>
        </div>

        <!-- Orders List -->
        <div class="orders-container">
          <div class="order-item" 
               *ngFor="let order of getOrdersForDate(day)"
               [ngClass]="{
                 'status-unassigned': order.load_status.toLowerCase() === 'unassigned',
                 'status-scheduled': order.load_status.toLowerCase() === 'scheduled',
                 'status-loaded': order.load_status.toLowerCase() === 'loaded',
                 'status-delivered': order.load_status.toLowerCase() === 'delivered'
               }">
            <div class="order-content">
              <div class="customer-info">
                <span class="supplier">{{ (getCustomerName(order.supplier_id)).slice(0, 15) }}{{ getCustomerName(order.supplier_id).length > 15 ? '...' : '' }}</span>
              </div>
              <i class="pi pi-arrow-down route-arrow"></i>
              <div class="customer-info">
                <span class="receiver">{{ getCustomerName(order.receiver_id).slice(0, 15) }}{{ getCustomerName(order.receiver_id).length > 15 ? '...' : '' }}</span>
              </div>
            </div>
          </div>
          
          <!-- Empty state when no orders -->
          <div *ngIf="getOrdersForDate(day).length === 0" class="empty-day">
            <i class="pi pi-calendar text-300"></i>
            <span class="text-300 text-sm">No orders</span>
          </div>
        </div>
      </div>
    </div>
  </div>

